/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetFamilyPathParameters } from 'api/actions/get-family/get-family-path-parameters';
import { GetFamilyResponse } from 'api/actions/get-family/get-family-response';

type GetFamilyQueryParameters = Record<string, any>;

/**
 * The path of the GetFamily action.
 */
export const getFamilyActionPath = new SweetPath<keyof GetFamilyPathParameters>('/user/family', { path: '{param}' });

/**
 * Creates a contextualized GetFamily actions.
 */
export default function createGetFamilyAction(axios: AxiosInstance) {
  return function getFamilyAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetFamilyQueryParameters } = {}) {
    const path = getFamilyActionPath.original;

    return axios.get<GetFamilyResponse, GetFamilyResponse>(path, { params: query, headers });
  };
}
